import { errorValidation } from './utils';

(() => {
    const $form = $("form[name='login']");
    $form.validate({
        ignore: [],
        ...errorValidation,
        errorClass: 'form__error',
        rules: {
            'login[email]': {
                required: true,
                email: true,
            },
            'login[password]': {
                required: true,
            },
        },
        messages: {
            'login[email]': {
                required: window.translations.required,
                email: window.translations.emailInvalid,
            },
            'login[password]': {
                required: window.translations.required,
            },
        },
        submitHandler: (form) => {
            form.submit();
        },
        success: function (label) {
            let name = label.attr('for');
            label.text('');
        },
    });
})();
